import { render, staticRenderFns } from "./RedesTematicas.vue?vue&type=template&id=6dc7dfc9&"
import script from "./RedesTematicas.vue?vue&type=script&lang=js&"
export * from "./RedesTematicas.vue?vue&type=script&lang=js&"
import style0 from "./RedesTematicas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports